import type { CatalogName } from "@core/types";

export interface CatalogPresentation {
  catalog: CatalogName;
  label: string;
  hasAttributes:
    | "action"
    | "model"
    | "color"
    | "maintenance"
    | "service"
    | "workshop"
    | "merchant"
    | null;
}

// Los nombres son las quince entradas que publica el contrato. No hay datos
// semilla: conteos, usos y contenido vienen exclusivamente de la API.
export const CATALOG_PRESENTATION: CatalogPresentation[] = [
  {
    catalog: "member-actions",
    label: "Acciones del miembro",
    hasAttributes: "action",
  },
  {
    catalog: "referral-actions",
    label: "Acciones del referido",
    hasAttributes: "action",
  },
  { catalog: "car-models", label: "Modelos de auto", hasAttributes: "model" },
  { catalog: "colors", label: "Colores", hasAttributes: "color" },
  {
    catalog: "reward-categories",
    label: "Categorías de recompensa",
    hasAttributes: null,
  },
  {
    catalog: "benefit-categories",
    label: "Categorías de beneficio",
    hasAttributes: null,
  },
  {
    catalog: "offer-categories",
    label: "Categorías de oferta",
    hasAttributes: null,
  },
  {
    catalog: "id-types",
    label: "Tipos de identificación",
    hasAttributes: null,
  },
  {
    catalog: "maintenance-types",
    label: "Tipos de mantenimiento",
    hasAttributes: "maintenance",
  },
  { catalog: "workshops", label: "Talleres", hasAttributes: "workshop" },
  {
    catalog: "service-types",
    label: "Tipos de servicio",
    hasAttributes: "service",
  },
  {
    catalog: "inactivation-reasons",
    label: "Motivos de inactivación",
    hasAttributes: null,
  },
  {
    catalog: "adjustment-reasons",
    label: "Motivos de ajuste de puntos",
    hasAttributes: null,
  },
  { catalog: "cities", label: "Ciudades", hasAttributes: null },
  {
    catalog: "merchants",
    label: "Comercios asociados",
    hasAttributes: "merchant",
  },
];

export function presentationFor(catalog: CatalogName) {
  return CATALOG_PRESENTATION.find((entry) => entry.catalog === catalog)!;
}

// admin.jsx:3685 TIPOS_ALIADO, mapeado a los valores del contrato
// (MerchantAttributes.type). Compartido por CatalogEntryForm y las
// composiciones especializadas de CatalogsScreen.
export const MERCHANT_TYPES = [
  ["authorized_workshop", "Taller autorizado"],
  ["dealership", "Concesionario"],
  ["hospitality", "Hotelería"],
  ["gastronomy", "Gastronomía"],
  ["automotive_detailing", "Estética automotriz"],
  ["experience_club", "Club / experiencia"],
  ["roadside_assistance", "Asistencia en vía"],
] as const;
